import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Box, Paper } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'
import DeleteIcon from '@mui/icons-material/Delete'
import { Alert, Button } from '@carsys/ui'
import { useMutation } from '@cbgms/base/http/use-query'
import { postPortalArchiveOrderCleanup } from '@cbgms/api/modules/support/requests'

interface Props {}

export const DeveloperSettingsDashboard: React.FC<Props> = ({}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [alertMessage, setAlertMessage] = useState('')
  const alertLevel: 'error' | 'success' = alertMessage.indexOf('Error') > -1 ? 'error' : 'success'

  const submitHandler = useMutation(async () => {
    try {
      const { Data } = await dispatch(postPortalArchiveOrderCleanup())
      setAlertMessage(`Success: ${Data?.Count || 0} cleaned up`)
    } catch (e: any) {
      setAlertMessage(`Error: ${e.toString?.()}`)
    }
  })

  return (
    <Box sx={{ display: ' flex' }}>
      <Paper sx={{ padding: 2 }}>
        <Box>
          <LoadingButton
            startIcon={<DeleteIcon />}
            variant='contained'
            color='primary'
            loading={submitHandler.isLoading}
            title={t('developer_settings.clean-up-portal-archive-orders_info_title')}
            onClick={() => submitHandler.mutate()}
          >
            {t('developer_settings.clean-up-portal-archive-orders')}
          </LoadingButton>
        </Box>

        {alertMessage && (
          <Alert
            sx={{ marginTop: 1 }}
            severity={alertLevel}
            action={
              <Button color='inherit' variant='text' onClick={() => setAlertMessage('')}>
                {t('global.clear_btn')}
              </Button>
            }
          >
            {alertMessage}
          </Alert>
        )}
      </Paper>
    </Box>
  )
}

export default DeveloperSettingsDashboard
